// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 任务类型枚举 枚举类
 * 任务类型枚举，根据任务类型约定具体的任务
 */
export enum EnumTaskType {
  /** 建库或升级 : 建库或升级 */
  DDL = 1,
  /** 执行脚本 : 执行脚本 */
  Script = 2
}

/**
 * 任务类型枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumTaskTypeMD {
  private static items = [
    new EnumItemMD('DDL', 1, '建库或升级', '建库或升级'),
    new EnumItemMD('Script', 2, '执行脚本', '执行脚本')
  ];

  static getItem(enumItem: EnumTaskType) {
    return this.items.find(item => item.name === EnumTaskType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
